import { SharedModule } from 'src/app/shared/shared.module';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CartItemEffects } from './cart-item.effects';
import * as fromCartItem from './cart-item.reducer';
import { CartItemSerializer } from './cart-item.serializer';
import { CartItemService } from './cart-item.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromCartItem.FEATURE_NAME,
      fromCartItem.cartItemReducer
    ),
    EffectsModule.forFeature([CartItemEffects])
  ],
  providers: [
    CartItemService,
    {
      provide: CartItemSerializer,
      useClass: CartItemSerializer
    }
  ],
  declarations: []
})
export class CartItemModule {}
